export default "__VITE_ASSET__a4692be2__"